export default class Blog {
  constructor() {
    this.heroCarousel = $('.blog-hero .slider-blog-hero');
    this.init();
  }

  init() {
    // Initialize blog hero carousels
    this.heroCarousel.each(function() {
      const $container      = $(this);
      const $slidesImages   = $container.find('.js-slides-images');
      const $sliderPrev     = $container.find('.slider__prev');
      const $sliderNext     = $container.find('.slider__next');

      $slidesImages.slick({
        infinite: true,
        autoplay: true,
        dots: true,
        slidesToShow: 1,
        centerMode: false,
        //centerPadding: '0',
        prevArrow: $sliderPrev,
        nextArrow: $sliderNext,
        adaptiveHeight: true,
        draggable: false,
        swipe: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              centerPadding: '20vw'
            }
          },
          {
            breakpoint: 767,
            settings: {
              centerPadding: '10vw'
            }
          }
        ]
      });
    });
  }
}
